import { useState } from 'react';
import { useSession } from '../../../../../context/SessionProvider';
import { useGetAllOfficers } from '../../../../../services/api/generated/client';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import useSearch from '../../../../../hooks/useSearch';
const useAssignInspectorsFormField = (onChange, assignee) => {
    const [assignedInspector, setAssignedInspector] = useState(assignee);
    const sessionUser = useSession();
    const { searchQuery, debouncedSetSearchQuery } = useSearch();
    const { data: response, isFetching, isFetched, } = useGetAllOfficers({
        'filter[search_query]': searchQuery !== '' ? searchQuery : undefined,
    }, {
        query: {
            enabled: !!searchQuery,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    });
    const inspectors = unwrapModel(response);
    const inspectorSearchResults = inspectors?.map((inspector) => ({
        full_name: inspector.full_name,
        id: inspector.id,
    }));
    const onRemoveAssignedInspector = () => {
        setAssignedInspector(undefined);
        onChange(undefined);
    };
    const onSelectInspectorResult = (inspectorResult) => {
        if (assignedInspector?.id !== inspectorResult.id) {
            setAssignedInspector(inspectorResult);
            onChange(inspectorResult);
        }
    };
    const onAssignToMe = () => {
        const updatedInspector = {
            id: sessionUser.id,
            full_name: sessionUser.full_name,
        };
        setAssignedInspector(updatedInspector);
        onChange(updatedInspector);
    };
    const onAssignKeyDown = (e) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            onAssignToMe();
        }
    };
    const showNoneAssignedMessage = !assignedInspector;
    return {
        onAdd: onSelectInspectorResult,
        onRemove: onRemoveAssignedInspector,
        inspectorSearchResults,
        assignedInspector,
        showNoneAssignedMessage,
        onAssignToMe,
        onAssignKeyDown,
        onSearch: debouncedSetSearchQuery,
        isFetching,
        isFetched,
    };
};
export default useAssignInspectorsFormField;
